import React, { useEffect, useState } from 'react';
import { devApi } from '../../services/api';
import {
  PageTitle,
  PageDescription,
  Card,
  Table,
  ErrorMessage,
  LoadingMessage,
} from './styles';

export default function DevAthletes() {
  const [athletes, setAthletes] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    devApi
      .getAthletes()
      .then((res) => {
        if (!cancelled) {
          setAthletes(Array.isArray(res) ? res : []);
          setError(null);
        }
      })
      .catch((err: any) => {
        if (!cancelled) {
          setError(err?.response?.data?.message || err?.message || 'Failed to load athletes');
          setAthletes([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <LoadingMessage>Loading athletes…</LoadingMessage>;
  }
  if (error) {
    return (
      <>
        <PageTitle>Athletes</PageTitle>
        <ErrorMessage>{error}</ErrorMessage>
      </>
    );
  }

  return (
    <>
      <PageTitle>Athletes</PageTitle>
      <PageDescription>Athletes with ID and connected coach(es).</PageDescription>
      <Card>
        <Table>
          <thead>
            <tr>
              <th>Athlete ID</th>
              <th>Name</th>
              <th>Plan</th>
              <th>Connected coaches</th>
            </tr>
          </thead>
          <tbody>
            {athletes.map((a) => (
              <tr key={a.id}>
                <td style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{a.athleteId}</td>
                <td>
                  {a.firstName} {a.lastName}
                </td>
                <td>{a.plan || 'free'}</td>
                <td>
                  {(a.coaches || [])
                    .map((c: any) => (c.firstName && c.lastName ? `${c.firstName} ${c.lastName} (${c.email})` : c.id))
                    .join(' · ') || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
